<template>
	<div>
		<div v-if="modulo">
			<div class="position-relative w-100">
				<img src="/assets/images/desktop/actividades.png"
				     class="w-100 d-none d-xl-block d-lg-block d-md-none d-sm-none"
				     draggable="false"
				     alt="">
				<img src="/assets/images/movil/actividades.png"
				     class="w-100 d-block d-xl-none d-lg-none d-md-block d-sm-block"
				     draggable="false"
				     alt="">
				<div class="position-absolute w-100 h-100 top-0 start-0">
					<div class="container h-100">
						<div class="row h-100">
							<div
								class="col-8 offset-2 offset-xl-0 offset-lg-0 offset-md-2 offset-sm-2 d-flex align-items-center">
								<div class="row w-100">
									<div
										class="col-xl-6 col-lg-6 col-md-12 col-sm-12 d-flex justify-content-center align-items-center">
										<div
											class="align-self-center text-center text-xl-start text-lg-start text-md-center text-sm-center text-white h1 fs-1 mb-5"
											v-html="modulo.name"></div>
									</div>
									<div
										class="col-xl-6 col-lg-6 col-md-12 col-sm-12 d-flex justify-content-center align-items-center">
										<img :src="'/assets/images/iconos-modulos/' + modulo.image"
										     class="w-50"
										     draggable="false"
										     :alt="modulo.name"/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="border-5 border-bottom border-cyan"></div>
			<div class="container">
				<div class="row py-5">
					<div class="col-6 mb-5 h1 text-cyan" v-html="modulo.title"></div>
					<div class="col-12">
						<p class="text-blue" v-html="modulo.text"></p>
					</div>
				</div>
			</div>
			<div v-if="modulo.info.type === 'slide'" class="bg-dark-gray py-5">
				<div class="container">
					<div class="row justify-content-center">
						<div class="col-10">
							<div id="carousel-actividad" class="carousel slide" data-bs-ride="carousel">
								<div class="carousel-inner">
									<div v-for="(data, index) in modulo.info.data" class="carousel-item"
									     :class="{active: index === 0}">
										<img :src="createURLImage(data.img)"
										     class="d-block w-100" alt="...">
										
										<div class="pt-5 text-center">
											<a class="btn btn-lg bg-white text-cyan rounded-pill"
											   target="_blank"
											   :href="createURLPdf(data.pdf)">
												<b>Descargar</b>
											</a>
										</div>
									</div>
								</div>
								<template v-if="modulo.info.data.length > 1">
									<button class="carousel-control-prev" type="button"
									        data-bs-target="#carousel-actividad" data-bs-slide="prev">
										<i class="fas fa-caret-left control-prev-icon fa-fw"></i>
										<span class="visually-hidden">Previous</span>
									</button>
									<button class="carousel-control-next" type="button"
									        data-bs-target="#carousel-actividad" data-bs-slide="next">
										<i class="fas fa-caret-right control-next-icon fa-fw"></i>
										<span class="visually-hidden">Next</span>
									</button>
								</template>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-if="modulo.info.type === 'video'">
				<div class="container py-5">
					<div class="row">
						<div v-for="video in modulo.info.data"
						     class="col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-5">
							<div class="ratio ratio-16x9">
								<iframe :src="'https://www.youtube.com/embed/'+video+'?rel=0'"
								        :title="video.title" allowfullscreen></iframe>
							</div>
						</div>
					</div>
				</div>
			</div>
			<template v-if="modulo.info.type === 'tab'">
				<div class="bg-light-yellow py-5">
					<div class="container">
						<div class="row">
							<div class="col-10 offset-1">
								<ul class="nav nav-pills nav-justified custom-pills" id="myTab" role="tablist">
									<li v-for="(data, index) in modulo.info.data"
									    class="nav-item m-3">
										<div class="nav-link py-4 h-100"
										     :class="{active: index === 0}"
										     data-bs-toggle="tab"
										     :data-bs-target="'#tab-' + index"
										     type="button"
										     aria-selected="true">
											<div class="row h-100">
												<div class="col-8 h-100 d-flex align-items-center">
													<span class="h5 text-white text-start" v-html="data.title"></span>
												</div>
												<div
													class="col-4 h-100 d-flex align-items-center justify-content-center">
													<img :src="'/assets/images/iconos-modulos/' + data.image"
													     class="w-100"
													     draggable="false"
													     :alt="data.title"/>
												</div>
											</div>
										</div>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
				<div class="container">
					<div class="row">
						<div class="col-12 py-5">
							<div class="tab-content">
								<div v-for="(data, index) in modulo.info.data"
								     :id="'tab-' + index"
								     class="tab-pane fade"
								     :class="{'show active': index === 0}">
									<div class="h1 text-dark-pink" v-html="data.title"></div>
									<p class="text-blue" v-html="data.text"></p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
		</div>
		<banda-ver-saludos/>
	</div>
</template>

<script>
import BandaVerSaludos from "../layout/BandaVerSaludos";
import {Mock} from "../common/mock";

export default {
	name: "actividades",
	components: {BandaVerSaludos},
	mounted() {
		if (this.$route.params.modulo) {
			const modulo = this.$route.params.modulo.toString();
			if (this.modulos.hasOwnProperty(modulo)) {
				this.key = modulo;
				this.modulo = this.modulos[modulo];
			} else {
				this.$router.push('/');
			}
		}
	},
	data: () => ({
		key: null,
		modulo: null,
		modulos: Mock.contenido_modulos_2023,
		
	}),
	methods: {
		createURLImage(image) {
			return '/assets/images/modulos-2023/' + this.key + '/' + image;
		},
		createURLPdf(pdf) {
			return '/assets/images/modulos-2023/' + this.key + '/' + pdf;
		},
	}
}
</script>